import { createAction } from '../../../../../store.model';
import { FilterOptions } from '../../../../transcript-dialog/model/filter-options.model';
import { ActionType } from '../teamschat-transcript-dialog.action';

export interface FilterQuotes {
    opts: FilterOptions;
}

export const filterQuotes = createAction<ActionType, FilterQuotes>(
    ActionType.COACHING_DETAIL__TCTD__FILTER_QUOTES,
);
